import axios from 'axios'

export const processDownload = async (token, filePath, title, setTitleFn = null) => {
  const accessToken = token?.token?.access_token

  if (setTitleFn != null) {
    setTitleFn(title)
  }

  try {
    const headers = {
      'Access-Control-Allow-Origin': '*',
      'x-user-token': 'Bearer ' + accessToken,
    }

    const response = await axios({
      url: filePath,
      method: 'GET',
      responseType: 'blob',
      headers,
    })

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', title)
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
    link.remove()
  } catch (error) {
    console.log(error.message)
  } finally {
    setTitleFn('')
  }
}
